<div mat-dialog-title>
    <h2>{{ 'transactions.edit-card-details' | translate }}</h2>
  </div>
  <mat-progress-bar mode="determinate"></mat-progress-bar>

<form
  fxLayout="column"
  fxLayoutGap="10px"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  autocomplete="off">
  <mat-dialog-content>
    <div fxLayout="column">
      <div
        fxLayout="row"
        fxLayoutGap="1rem"
        fxLayoutAlign="space-between start">
        <mat-form-field appearance="fill" fxFlex>
          <mat-label>{{ 'transactions.edit-card-details-month' | translate }}</mat-label>
          <input matInput type="number" formControlName="expirationMonth"/>
          <mat-error *ngIf="form.get('expirationMonth').invalid">{{ getErrorMessage('expirationMonth') }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" fxFlex>
            <mat-label>{{ 'transactions.edit-card-details-year' | translate }}</mat-label>
            <input matInput type="number" formControlName="expirationYear"/>
            <mat-error *ngIf="form.get('expirationYear').invalid">{{ getErrorMessage('expirationYear') }}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-stroked-button mat-dialog-close type="button">
      {{ 'common.cancel' | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="form.invalid">
      {{ 'common.save' | translate }}
    </button>
  </mat-dialog-actions>
</form>